export default class NickNames {
  names!: string[] | null;
  type!: string | null;
  language!: string | null;
  preference!: number | null;
  alternativeId!: string | null;

  constructor() {
    this.names = null;
    this.type = null;
    this.language = null;
    this.preference = null;
    this.alternativeId = null;
  }
}
